import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// CSRF double-submit: mirror the (non-httpOnly) csrf_token cookie into a header on state-changing calls.
client.interceptors.request.use((config) => {
  const m = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  if (m && !["get", "head", "options"].includes((config.method || "get").toLowerCase())) {
    config.headers["X-CSRF-Token"] = decodeURIComponent(m[1]);
  }
  return config;
});

// SEC-001: rely exclusively on the httpOnly cookie (no token in browser storage).
// Purge any legacy token that may still be in localStorage from previous versions.
// Silent catch: private-browsing / storage-disabled is an expected no-op.
try { localStorage.removeItem("ga_token"); } catch (_) { /* storage unavailable */ }

client.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const detail = error.response?.data?.detail;
    if (error.response?.status === 403 && typeof detail === "string" && detail.includes("CSRF") && !cfg.__csrfRetried) {
      cfg.__csrfRetried = true;
      try { await client.get("/auth/me"); } catch (_) { /* ignore */ }
      return client(cfg);
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
